import { render, staticRenderFns } from "./commondepartment.vue?vue&type=template&id=166f2f27&scoped=true&"
import script from "./commondepartment.vue?vue&type=script&lang=js&"
export * from "./commondepartment.vue?vue&type=script&lang=js&"
import style0 from "./commondepartment.vue?vue&type=style&index=0&id=166f2f27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f2f27",
  null
  
)

export default component.exports